import { render, staticRenderFns } from "./globalVScrollContainer.vue?vue&type=template&id=476e503e"
import script from "./globalVScrollContainer.vue?vue&type=script&lang=js"
export * from "./globalVScrollContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports